import { BaseEntity } from ".";
import { IGet_corporation_corporation_id_mining_observers_observer_id_200_ok } from "../service/esiclient";
import moment from "moment";
import { getCachedTypeEntity } from "./TypeEntityCache";
import { getCachedCharacterEntity } from "./CharacterEntityCache";

export class CorporationMiningDetailEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Corporation Mining Details";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_corporation_corporation_id_mining_observers_observer_id_200_ok> = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      let name = "Unknown";
      if (props.type_id) {
        const type = await getCachedTypeEntity(props.type_id);
        name = type?.props.name;
        entity.properties["type_id"] = {
          type: Excel.CellValueType.double,
          basicValue: props.type_id,
        };
      }
      if (props.character_id) {
        entity.properties["character_id"] = {
          type: Excel.CellValueType.double,
          basicValue: props.character_id,
        };
        const character = await getCachedCharacterEntity(props.character_id);
        if (character !== null) {
          entity.properties["character_name"] = {
            type: Excel.CellValueType.string,
            basicValue: character.props.name,
          };
        }
      }
      if (props.quantity) {
        name += " x " + props.quantity;
        entity.properties["quantity"] = {
          type: Excel.CellValueType.double,
          basicValue: props.quantity,
        };
      }
      if (props.recorded_corporation_id) {
        entity.properties["corporation_id"] = {
          type: Excel.CellValueType.double,
          basicValue: props.recorded_corporation_id,
        };
      }
      if (props.last_updated) {
        const last_updated = moment(props.last_updated);
        entity.properties["last_updated"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: last_updated.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      entity.text = name;
      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: entity.text,
      };
    }
    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
